import {Component, EventEmitter, input, Input, model, OnInit, output, Output} from '@angular/core';
import {NotificationMessage, NotificationSeverity, NotificationType} from '../../../../models/notification-message';
import {RestApiService} from '../../../../services/api';
import {NotificationComponent} from '../../../../components/notifications/notification/notification.component';
import {Message} from 'primeng/message';
import {ActionButtonComponent} from '../../../../components/form/action-buttons/action-button.component';

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrls: ['./notifications-list.component.scss'],
    imports: [
        NotificationComponent,
        Message,
        ActionButtonComponent
    ]
})
export class NotificationsListComponent implements OnInit {

    notifications = model<NotificationMessage[]>([]);

    readAll = output();

    isReadingAll = false;

    constructor(private api: RestApiService) {
    }

    ngOnInit(): void {
    }

    readNotification({notificationId}: {notificationId: number}) {
        const index = this.notifications().findIndex(n => n.notificationId === notificationId);
        if (index >= 0) {
            this.notifications.update(value => {
                value.splice(index, 1);
                return value;
            });
        }
    }

    async readAllNotifications() {
        this.isReadingAll = true;
        try {
            await this.api.notifications.readAllNotification();
        } finally {
            this.readAll.emit();
            this.isReadingAll = false;
        }
    }
}
